import { SerializedError } from "@reduxjs/toolkit";
import axios from "axios";
import applyCaseMiddleware from "axios-case-converter";

import { routes } from "@/api/services/routes";
import { lvtResponseLiveUnitInfoValidator, lvtResponseLiveUnitMetadataValidator } from "@/api/validation/liveUnitMeta";
import { logError } from "@/utilities/api";
import { LiveUnitMetaLanding, LiveUnitInfo } from "@/utilities/types/liveunit";

import { LiveUnitMetadataService } from "../interfaces/LiveUnitMetadata";


axios.defaults.withCredentials = true;

const client = applyCaseMiddleware(axios.create());

export const liveUnitMetadataService: LiveUnitMetadataService = {
    async fetchLiveUnitMetadataLanding(liveUnitId: number): Promise<LiveUnitMetaLanding> {
        const route = routes.getLiveUnitMetaDataLanding(liveUnitId);

        try {
            const response = await client.get(route);

            if (lvtResponseLiveUnitMetadataValidator(response.data)) {
                return response.data.data as LiveUnitMetaLanding;
            } else {
                const error: SerializedError = {
                    name: "validation",
                    message: JSON.stringify(lvtResponseLiveUnitMetadataValidator.errors),
                };

                throw error;
            }
        } catch (error) {
            logError(route, error as Error);
            throw error;
        }
    },
    async fetchLiveUnitInfo(liveUnitId: number): Promise<LiveUnitInfo> {
        const route = routes.getLiveUnitInfo(liveUnitId);

        try {
            const response = await client.get(route);

            if (lvtResponseLiveUnitInfoValidator(response.data)) {
                return response.data.data as LiveUnitInfo;
            } else {
                const error: SerializedError = {
                    name: "validation",
                    message: JSON.stringify(lvtResponseLiveUnitInfoValidator.errors),
                };

                throw error;
            }
        } catch (error) {
            logError(route, error as Error);
            throw error;
        }
    },
};
